import flow from 'lodash/flow';
import isNil from 'lodash/isNil';
import classNames from 'clsx';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Slider from 'material-ui/Slider';
import { setVolume, toggleMuteVolume } from 'src/common/actions/player';
import { getVolume as getVolumefromStorage } from 'src/common/utils/storage/playerVolume';
import VolumeControlIcon from '../../shared/svgIcons/player/VolumeControlIcon';
import VolumeControlOffIcon from '../../shared/svgIcons/player/VolumeControlOffIcon';
import withParentHover from '../../../decorators/hovers/withParentHover';
import css from './action-drawer.module.scss';

const styles = {
  slider: {
    position: 'absolute',
    top: -100,
    left: 50,
    height: 100,
    backgroundColor: '#fff',
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 0,
    paddingTop: 15,
    borderRadius: '3px 3px 0 0',
    boxShadow: '0 -2px 5px 0 rgba(0, 0, 0, .05)',
  },
  innerSlider: {
    marginTop: 0,
    cursor: 'pointer',
  },
};

export class VolumeControl extends Component {
  static propTypes = {
    isHovering: PropTypes.bool.isRequired,
    volume: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired,
    videoPrerollIsPlaying: PropTypes.bool.isRequired,
    showVolumeBar: PropTypes.bool.isRequired,
    iconContainerClass: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.setVolumeControl();
  }

  setVolumeControl() {
    const volumeFromStorage = getVolumefromStorage();
    const volumeToSet =
      isNil(volumeFromStorage) || isNaN(volumeFromStorage)
        ? this.props.volume
        : volumeFromStorage;

    this.props.actions.setVolume(volumeToSet);
  }

  handleSliderChange = (event, value) => {
    this.props.actions.setVolume(value);
  };

  handleOnClickMute = () => {
    if (!this.props.videoPrerollIsPlaying) {
      this.props.actions.toggleMuteVolume();
    }
  };

  render() {
    const {
      isHovering,
      videoPrerollIsPlaying,
      iconContainerClass,
      volume,
      showVolumeBar,
    } = this.props;

    const sliderVisibility =
      (isHovering && !videoPrerollIsPlaying) || showVolumeBar
        ? 'visible'
        : 'hidden';

    const VolumeIconComponent = volume
      ? VolumeControlIcon
      : VolumeControlOffIcon;
    return (
      <div id="playerVolumeContainer" className={css.volumeTopMarginFix}>
        <div
          id="playerVolume"
          data-testid="playerVolume"
          data-volume={volume}
          className={classNames(iconContainerClass, {
            [css.disabledVolume]: videoPrerollIsPlaying,
          })}
          onClick={this.handleOnClickMute}
        >
          <VolumeIconComponent
            className={css.overflowVisible}
            width="17px"
            height="16px"
          />
        </div>
        <Slider
          id="playerVolumeSlider"
          style={{ ...styles.slider, visibility: sliderVisibility }}
          sliderStyle={styles.innerSlider}
          value={volume}
          max={100}
          axis="y"
          onChange={this.handleSliderChange}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  volume: state.player.volume,
  videoPrerollIsPlaying: state.preroll.prerollDialogOpen,
  showVolumeBar: state.player.showVolumeBar,
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setVolume,
        toggleMuteVolume,
      },
      dispatch,
    ),
  };
}

export default flow(
  connect(mapStateToProps, mapDispatchToProps),
  withParentHover,
)(VolumeControl);
